import React from 'react'
import HeaderSix from '../components/header/HeaderSix'
import FooterSix from '../components/footer/FooterSix'
import ContactPageBreadcrumb from '../components/techdigit/contact/ContactPageBreadcrumb'
import ContactPageMain from '../components/techdigit/contact/ContactPageMain'

function ContactUs() {
    return (
        <div className="index-six contact-page">
            <HeaderSix />
            <main>
                <ContactPageBreadcrumb />
                <ContactPageMain />
            </main>
            <FooterSix />
        </div>
    )
}

export default ContactUs
